<script setup>
import { defineProps } from 'vue'
import { KNOLIA } from '../knolia'

const props = defineProps({
  element: { type: Object, required: true },
  ratingData: { type: Object, required: true },
  mobileView: { type: Boolean, default: false },
  validateSkills: { type: Boolean, default: false }
})

function UseRequestedRatingStyle(element, i) {
  if(element.current_rating >= i)
    return false

  if(element.rating != element.current_rating) {
    return element.rating > element.current_rating
  }

  return element.rating != element.current_rating && element.current_rating < element.rating
}

function DivRatingFrameCss(element, i) {
  let cssClassName = ''

  if(element.current_rating >= i || element.rating >= i)
    cssClassName += ` opt-color-${i}`

  if(element.rating == i)
    cssClassName += ' rating-selected'

  return cssClassName
}

function IsRatingBelowValidated(rating) {
  if(KNOLIA.ToBoolean(props.element.waiting_validation))
    return props.element.rating != rating
  
  if(props.element.current_rating > rating)
    return true
}
</script>

<template>
  <div class="div-rating-frame" v-for="i in 6" :key="i" :class="DivRatingFrameCss(props.element, i)" :id="!props.mobileView ? `opt-${i}` : ''"
   @mouseenter="props.ratingData.CheckForTooltip($event, i, props.element)">
    <div class="div-inner-rating-scale" :class="{'div-inner-rating-scale-requested': UseRequestedRatingStyle(props.element, i)}">
      <input :class="{'cursor-pointer': !IsRatingBelowValidated(i)  && !props.validateSkills}" type="radio" :value="i" :checked="props.element.rating == i"
        :disabled="IsRatingBelowValidated(i) || props.validateSkills" @click="props.ratingData.SetRating(props.element, i)">
      <label>{{ i }}</label>
    </div>
  </div>
</template>

<style scoped>
.radios {
  display: flex;
  font-size: 1.2em;
  justify-content: center;
}

.div-rating-frame input {
  margin-right: 6px;
  transform: scale(1.3);
}

.div-rating-frame:first-child,
.div-rating-frame:first-child .div-inner-rating-scale {
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  border-left: 4px solid transparent;
}

.div-rating-frame:last-child,
.div-rating-frame:last-child .div-inner-rating-scale {
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  border-right: 4px solid transparent;
}

.div-rating-frame {
  display: inline-flex;
  background-color: var(--knolia-rating-scale);
  flex: 1;
  position: relative;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
}

.div-rating-frame:first-child::before {
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
}

.div-inner-rating-scale {
  background: transparent;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 29px;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

.div-inner-rating-scale-requested {
  background: var(--knolia-rating-scale);
  width: 100%;
}

.rating-selected .div-inner-rating-scale {
  border-right-color: var(--color);
}

.opt-color-1 {
  --color: #0096B4;
}

.opt-color-2 {
  --color: #00AAA0;
}

.opt-color-3 {
  --color: #00BE8C;
}

.opt-color-4 {
  --color: #00D278;
}

.opt-color-5 {
  --color: #00E664;
}

.opt-color-6 {
  --color: #00FF50;
}

.opt-color-1,
.opt-color-2,
.opt-color-3,
.opt-color-4,
.opt-color-5,
.opt-color-6 {
  color: white;
  background-color: var(--color) !important;
}

@media screen and (max-width: 1200px) {
  #opt-4 {
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
    padding-left: 10px;
  }

  #opt-3 {
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
    padding-right: 10px;
  }
}

@media screen and (max-width: 765px) {
  .radios div input {
    margin-right: 6px;
    transform: scale(0.9);
  }

  .div-inner-rating-scale {
    height: 19px;
  }
}

@media screen and (max-width: 300px) {
  #opt-4 {
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
    padding-left: 10px;
  }

  #opt-3 {
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
    padding-right: 10px;
  }

  .div-inner-rating-scale {
    height: 10px;
  }
}
</style>